import require$$0 from '../../../../package.mjs';

const pkg = require$$0;

const versionClass = `lc-v${pkg.version.replace(/\./g, '-')}`; // Import pkg.version and turn it into a class that is then used in postcss.config.js and VersionScopedBase.tsx

var packageVersionAsClassName = versionClass;

export { packageVersionAsClassName as default };
//# sourceMappingURL=package-version-as-className.mjs.map
